import { __assign, __extends } from "tslib";
import { namespacedClassnames, isPromise } from '../../../common';
import * as React from 'react';
import { TinyLoader } from '../../loaders/tiny-loader';
import { Tooltip } from '../../tooltip/tooltip';
var defaultProps = {
    disabled: false,
    buttonType: 'default',
    size: 'normal'
};
/** @deprecated please use \<Button/> */
var DeprecatedBaseButton = /** @class */ (function (_super) {
    __extends(DeprecatedBaseButton, _super);
    function DeprecatedBaseButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.elemRef = null;
        _this.unMounted = false;
        _this.state = {
            loading: false
        };
        _this.startLoading = function () {
            var elem = _this.elemRef;
            if (elem && !_this.unMounted) {
                _this.setState({ loading: true, width: elem.offsetWidth });
            }
        };
        _this.stopLoading = function () {
            var elem = _this.elemRef;
            if (elem && !_this.unMounted) {
                _this.setState({ loading: false, width: undefined });
            }
        };
        _this.setRef = function (ref) { return _this.elemRef = ref; };
        _this.onClick = function (e) {
            var result = _this.props.onClick(e);
            if (result && isPromise(result)) {
                _this.startLoading();
                result.then(_this.stopLoading, _this.stopLoading);
            }
        };
        return _this;
    }
    DeprecatedBaseButton.prototype.componentWillUnmount = function () {
        this.unMounted = true;
    };
    DeprecatedBaseButton.prototype.render = function () {
        var props = __assign(__assign({}, defaultProps), this.props);
        var _a = this.state, loading = _a.loading, width = _a.width;
        var size = props.size, buttonType = props.buttonType, className = props.className;
        var hollow = props.isHollow;
        var disabled = props.disabled || loading;
        // tslint:disable-next-line: max-line-length
        var classNames = namespacedClassnames('deprecated-button', buttonType, size, className, { disabled: disabled, hollow: hollow, loading: loading });
        var content = loading ? React.createElement(TinyLoader, null) : props.children;
        var maybeStyle = loading ? { width: width } : {};
        var disabledMsg = (typeof disabled !== 'boolean') ? disabled : '';
        var buttonComp = (React.createElement("button", { style: maybeStyle, onClick: this.onClick, ref: this.setRef, disabled: !!disabled, className: classNames }, content));
        return !!disabledMsg ? (React.createElement(Tooltip, { body: disabledMsg, relativeToBody: true }, buttonComp)) : buttonComp;
    };
    return DeprecatedBaseButton;
}(React.PureComponent));
export { DeprecatedBaseButton };
//# sourceMappingURL=base-button.comp.js.map